import React from 'react'

import QrChannelPage from '../AddChannelPageWrapper/components/QrChannelPage'
import { channelTypes } from '../../utils/constants'

const AddMaxPage = () => {
   return <QrChannelPage channelType={channelTypes.MAX} />
}

export default AddMaxPage
